const CHAMPAGNE_LIGHT = '#F0C674';
const FG = '#F5F1FA';
const MUTED = '#A99FB8';

// ─── Dois pilares principais ────────────────────────────────────────────────

interface Pilar {
  title: string;
  desc: string;
}

const PILARES: Pilar[] = [
  {
    title: 'Zero intimação perdida',
    desc: 'Monitoramento automático do DJEN, a fonte oficial do CNJ. Cada intimação vira tarefa com o prazo já calculado e alertas antes do vencimento. O que mais tira o sono do advogado, resolvido.',
  },
  {
    title: 'Todos os tribunais num só lugar',
    desc: 'Pare de perder tempo acessando tribunal por tribunal. O VoxisAdv reúne suas intimações de todo o Brasil e sincroniza capa e movimentações direto dos sistemas, inclusive com certificado em nuvem (BirdId, Vidaas, Certisign).',
  },
  {
    title: 'Dashboard customizado',
    desc: 'Monte seu painel com os widgets que importam: clientes, processos, prazos, financeiro e intimações. Cada pessoa do escritório vê o que precisa, logo na abertura.',
  },
];

// ─── Componente principal ───────────────────────────────────────────────────

export function LandingDiferenciais() {
  return (
    <section
      style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: 1180,
        margin: '0 auto',
        padding: '16px clamp(16px, 4vw, 24px) 80px',
      }}
    >
      <style>{`
        @media (max-width: 600px) {
          .dif-pilares { grid-template-columns: 1fr !important; }
          .dif-banner { padding: 20px 18px !important; }
          .dif-pilar { padding: 24px 20px 20px !important; }
        }
      `}</style>
      {/* Parte 1 — Dois pilares */}
      <div
        className="dif-pilares"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 20,
          marginBottom: 40,
        }}
      >
        {PILARES.map((pilar) => (
          <PilarCard key={pilar.title} pilar={pilar} className="dif-pilar" />
        ))}
      </div>

      {/* Parte 3 — Banner de ancoragem */}
      <AnchoringBanner />
    </section>
  );
}

// ─── Pilar card (maior, destaque champagne) ─────────────────────────────────

function PilarCard({ pilar, className }: { pilar: Pilar; className?: string }) {
  return (
    <div
      className={className}
      style={{
        background: 'rgba(22,12,36,0.85)',
        border: `1px solid rgba(232,185,106,0.25)`,
        borderRadius: 16,
        padding: '36px 32px 32px',
        backdropFilter: 'blur(14px)',
        position: 'relative',
        overflow: 'hidden',
        transition: 'border-color 0.2s ease, transform 0.2s ease',
      }}
      onMouseEnter={(e) => {
        const el = e.currentTarget as HTMLDivElement;
        el.style.borderColor = 'rgba(232,185,106,0.5)';
        el.style.transform = 'translateY(-3px)';
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget as HTMLDivElement;
        el.style.borderColor = 'rgba(232,185,106,0.25)';
        el.style.transform = 'translateY(0)';
      }}
    >
      {/* Glow decorativo */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 200,
          height: 200,
          background:
            'radial-gradient(ellipse at top right, rgba(232,185,106,0.12) 0%, transparent 65%)',
          pointerEvents: 'none',
        }}
      />
      <h3
        style={{
          fontFamily: "'Fraunces', Georgia, serif",
          fontWeight: 400,
          fontSize: 'clamp(22px, 2.5vw, 28px)',
          lineHeight: 1.2,
          color: FG,
          marginBottom: 16,
          letterSpacing: '-0.01em',
        }}
      >
        {pilar.title}
      </h3>
      <p
        style={{
          fontFamily: "'Hanken Grotesk', sans-serif",
          fontSize: 15,
          lineHeight: 1.65,
          color: MUTED,
          margin: 0,
        }}
      >
        {pilar.desc}
      </p>
    </div>
  );
}

// ─── Banner de ancoragem ────────────────────────────────────────────────────

function AnchoringBanner() {
  return (
    <div
      className="dif-banner"
      style={{
        padding: '32px 36px',
        background: 'rgba(20,12,32,0.8)',
        border: '1px solid rgba(232,185,106,0.14)',
        borderRadius: 14,
        backdropFilter: 'blur(16px)',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 20,
      }}
    >
      <p
        style={{
          fontFamily: "'Hanken Grotesk', sans-serif",
          fontSize: 15.5,
          lineHeight: 1.55,
          color: MUTED,
          maxWidth: 640,
          margin: 0,
        }}
      >
        Os sistemas atuais cobram{' '}
        <strong style={{ color: FG }}>R$ 450+/mês</strong> e ainda falham no
        básico. Entre no primeiro lote e garanta condição de fundador.
      </p>
      <button
        onClick={() =>
          document.getElementById('acesso')?.scrollIntoView({ behavior: 'smooth' })
        }
        style={{
          background: 'rgba(232,185,106,0.12)',
          color: CHAMPAGNE_LIGHT,
          fontFamily: "'Hanken Grotesk', sans-serif",
          fontWeight: 600,
          fontSize: 14,
          letterSpacing: '0.01em',
          border: `1px solid rgba(232,185,106,0.28)`,
          borderRadius: 9,
          padding: '12px 24px',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          transition: 'background 0.18s ease',
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background =
            'rgba(232,185,106,0.22)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background =
            'rgba(232,185,106,0.12)';
        }}
      >
        Garantir acesso antecipado
      </button>
    </div>
  );
}
